import { render, staticRenderFns } from "./LogisticSubscribeList.vue?vue&type=template&id=ec829cf8&scoped=true"
import script from "./LogisticSubscribeList.vue?vue&type=script&lang=js"
export * from "./LogisticSubscribeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec829cf8",
  null
  
)

export default component.exports